<script setup lang="ts">
import { computed, ref } from 'vue'
import Button from '../button/Button.vue'
import Input from '../input/Input.vue'
import Modal from '@/components/Modal/Modal.vue'

type ConfirmationModalItem = string | { label: string; subItems?: string[] }

const props = defineProps<{
	title: string
	subtitle: string
	items: ConfirmationModalItem[]
	loading: boolean
	confirmationEmail?: string
}>()

const emit = defineEmits<{
	(event: 'cancel'): void
	(event: 'delete'): void
}>()

const typedEmail = ref('')

const normalizedItems = computed(() =>
	props.items.map((item) =>
		typeof item === 'string'
			? { label: item, subItems: [] as string[] }
			: { label: item.label, subItems: item.subItems ?? [] },
	),
)

const requiresEmail = computed(
	() => props.confirmationEmail != null && props.confirmationEmail !== '',
)

const isDeleteDisabled = computed(
	() =>
		requiresEmail.value &&
		typedEmail.value.trim().toLowerCase() !== (props.confirmationEmail ?? '').trim().toLowerCase(),
)
</script>

<template>
	<modal>
		<div
			style="display: flex"
			class="bg-white-neutral flex-col max-w-80 px-6 py-4 gap-4 rounded"
		>
			<label class="text-default">{{ title }}</label>
			<label class="text-default mt-2">{{ subtitle }}</label>
			<ul class="list-disc list-inside max-h-60 overflow-y-auto">
				<li
					v-for="(item, index) in normalizedItems"
					:key="index"
					class="text-s-bold py-1"
				>
					{{ item.label }}
					<ul
						v-if="item.subItems.length"
						class="list-disc list-inside ml-4"
					>
						<li
							v-for="(sub, subIndex) in item.subItems"
							:key="subIndex"
							class="text-s-bold py-1"
						>
							{{ sub }}
						</li>
					</ul>
				</li>
			</ul>

			<template v-if="requiresEmail">
				<label class="text-default">Não é possível reverter esta ação.</label>
				<label class="text-default"
					>Para continuar, insira o e-mail do usuário responsável pela ação:</label
				>
				<Input
					:value="typedEmail"
					type="email"
					placeholder="nome@dominio.com.br"
					@input="typedEmail = $event"
				/>
			</template>

			<div class="flex justify-between gap-4">
				<Button
					text="excluir"
					danger
					simple
					:loading="loading"
					:disabled="isDeleteDisabled"
					class="justify-center w-1/2"
					@click="emit('delete')"
				/>
				<Button
					text="cancelar"
					secondary
					simple
					class="justify-center w-1/2"
					@click="emit('cancel')"
				/>
			</div>
		</div>
	</modal>
</template>
